import LaunchIcon from '@mui/icons-material/Launch'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { EntityKpi } from '@components/EntityKpi'
import { MyListButton } from '@components/MyListButton'
import { formatDateTime } from '@util/date-util'

import { AssignedBijlageCaption } from '../../../core/components/AssignedBijlageCaption'
import type { AssignedBijlage } from '../../../entity/bijlagen/types/AssignedBijlage'
import { Label } from '../../../theme/components/Label'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'

const getEntityLabel = (type: string, projecttype?: string) => {
  return (
    projecttype ||
    {
      project: 'Project',
    }[type]
  )
}

interface Props {
  assignedBijlage: AssignedBijlage
}

export const AssignedBijlagenTableRow = ({ assignedBijlage }: Props) => {
  const {
    _id,
    documentsoort,
    assignedTo,
    dueWeek,
    discipline,
    netbeheerder,
    entity: { id: entityId, type: entityType, projecttype, gebiedscodeLabel },
    searchValues,
    myList,
    kpi,
    labels,
  } = assignedBijlage
  const { organisatie, date: created } = assignedBijlage.created

  return (
    <TableRow key={_id}>
      <TableCell>
        <EntityKpi kpi={kpi} />
      </TableCell>
      <TableCell>
        {`${documentsoort} ${discipline || ''}`}
        <AssignedBijlageCaption assignedBijlage={assignedBijlage} />
      </TableCell>
      <TableCell>{dueWeek}</TableCell>
      <TableCell>{formatDateTime(created)}</TableCell>
      <TableCell>{organisatie}</TableCell>
      <TableCell>
        {assignedTo}
        {netbeheerder && assignedTo !== netbeheerder && (
          <Typography variant="caption">
            <br />
            {`namens ${netbeheerder}`}
          </Typography>
        )}
      </TableCell>
      <TableCell>
        {getEntityLabel(entityType, projecttype)} <span>{entityId}</span>
      </TableCell>
      <TableCell>{searchValues?.adres}</TableCell>
      <TableCell>
        {gebiedscodeLabel}
        <br />
        {labels && labels.map((l) => <Label text={l} key={l} small={true} />)}
      </TableCell>
      <TableCell>
        <MyListButton
          type="aansluiting"
          disabled={true}
          active={myList}
          aanvraagID={''}
        />

        <StyledIconLink
          icon={<LaunchIcon />}
          title={`Navigeer naar ${entityType} ${entityId}`}
          href={`/aansluiting/${entityType}/${entityId}`}
        />
      </TableCell>
    </TableRow>
  )
}
